import { Vector3 } from 'three/webgpu'
import { IceField } from '../world/IceField.ts'
import type { GameMode, ModeContext } from './GameMode.ts'

/** Untimed icebreaking: power ahead and leave a navigable channel through the pack. */
export class IcebreakerMode implements GameMode {
  readonly ice = new IceField()
  readonly worldGroup=this.ice.group
  readonly tugSpawn={position:new Vector3(),heading:0}
  private crunchCooldown=0
  constructor(private readonly ctx:ModeContext) {}
  start():void {this.ctx.hud.announce('Sea Cruise ready — power ahead to break through the ice',5)}
  fixedStep(dt:number,elapsed:number):void {
    this.crunchCooldown-=dt
    if(this.ice.step(dt,elapsed,this.ctx.tug)>0&&this.crunchCooldown<=0) {this.ctx.engineSound.crash();this.crunchCooldown=.7}
  }
  frame(elapsed:number):void {
    this.ice.frame(elapsed)
    const {tug,hud,waypoint,chase}=this.ctx
    waypoint.update(tug.position,null,chase.camera);hud.setHookState(false,false)
    hud.setMission('Icebreaker · Clear a path',`${this.ice.brokenCount} floes broken · Keep moving ahead`,0)
  }
  toggleHook():void {}
  towWake():null{return null}
  dispose():void {this.ice.dispose()}
}
